import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const typeRef = useRef(null);

  useEffect(() => {
    // Fetch clients from API
    axios
      .get("https://www.isolsgroup.com/new/api/ApiClients", {
        headers: {
          "X-API-KEY": "ISOLS",
        },
      })
      .then((res) => {
        console.log("API Response:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setClients(res.data.data);
        } else {
          setClients([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
      })
      .finally(() => setLoading(false));

    // Typewriter effect
    const element = typeRef.current;
    if (!element) return;

    const toRotate = JSON.parse(element.getAttribute("data-type"));
    const period = parseInt(element.getAttribute("data-period"), 10) || 2000;

    let loopNum = 0;
    let text = "";
    let isDeleting = false;

    const tick = () => {
      const i = loopNum % toRotate.length;
      const fullText = toRotate[i];

      text = isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1);

      element.querySelector(".wrap").innerHTML = text;

      let delta = 200 - Math.random() * 100;
      if (isDeleting) delta /= 2;

      if (!isDeleting && text === fullText) {
        delta = period;
        isDeleting = true;
      } else if (isDeleting && text === "") {
        isDeleting = false;
        loopNum++;
        delta = 500;
      }

      setTimeout(tick, delta);
    };

    tick();
  }, []);

  return (
    <div className="page-container">
      {/* Breadcrumbs Header */}
      
         <BreadcrumbsHeader 
          title="Our Clients" 
          backgroundImage="/images/header/clients2.jpg" 
        />


      {/* Section Services */}
      <section className="section-services">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <div className="b-mod-heading text-center">
                <p className="first-heading font-secondary wow fadeInDown">
                  Glimpse of Our Clients
                </p>
                <h2 className="heading-line line-right customColor customPseudoElBg wow fadeIn">
                  <strong>Be a part of Happy Client Family</strong>
                </h2>
                <br />
                <div>
                  <h1
                    style={{ fontSize: "30px", color: "#222", textAlign: "center" }}
                    className="typewrite"
                    data-period="2000"
                    data-type='["Be A Part Of Happy Client Family.", "Be A Part Of Growing ISOLS Group.", "Be A Part Of Digital India Movement."]'
                    ref={typeRef}
                  >
                    <span className="wrap"></span>
                  </h1>
                </div>
                <p className="second-heading font-additional">
                  We have a sustained list of sincere happy clients comprising
                  of StartUps, SMEs &amp; MNCs who are progressing with a
                  visionary sight.
                  <br />
                  Our client serving mantra is: "Keep Your Clients Happy &amp;
                  they will Keep You Happy!"
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Clients Logos Section */}
        {loading ? (
          <p className="text-center">Loading clients...</p>
        ) : clients.length > 0 ? (
          <section className="section-works" style={{ padding: "0px" }}>
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12">
                  <div className="row">
                    <div className="partner-list text-center">
                      {clients.map((client, index) => (
                        <div
                          key={index}
                          className="col-md-2 col-sm-6 col-xs-12 wd-img"
                        >
                          <div
                            className="single-partner animated fadeInUp"
                            data-animate="fadeInUp"
                            data-delay=".6"
                            style={{
                              visibility: "visible",
                              animationDelay: "0.6s",
                            }}
                          >
                            <img
                              src={`https://www.isolsgroup.com/uploaded-images/client/${client.client_image}`}
                              alt={client.name || "Client Logo"}
                              className="img-responsive"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <p className="text-center">No clients available.</p>
        )}
      </section>

    </div>
  );
};

export default Clients;
